import React, { useEffect, useState } from "react";
import Left from "../Assets/images/Left.jpg";
import { NavLink, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../Assets/images/logo.png";
import { CiMail } from "react-icons/ci";
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { CiLock } from "react-icons/ci";
import axios from "../config/axios";
import Footer from "../components/Footer";
import { AiFillContacts } from 'react-icons/ai';
import './footer.css'
import { Link } from 'react-router-dom';
import { error } from "toastr";


const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState("");
  const [isFooterVisible, setFooterVisibility] = useState(false);
  const handleIconClick = () => {
    setFooterVisibility(!isFooterVisible);
    console.log("Working");

  };


  const navigate = useNavigate();
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast("Please enter your email and password to continue");
      return;
    }
    if (password.length < 8) {
      toast("Password should not be less than 8 characters");
      return;
    }
    console.log(password)
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (!email.match(validRegex)) {
      toast("Please enter a valid email adress");
      return;
    }
    try {
      console.log("response")
      const response = await axios.post("users/login", {
        email,
        password,
      }, {
        headers: {
          "Origin": "Access-Control-Allow-Origin",
        }
      },);
      if (response.status === 200) {
        console.log(response)
        sessionStorage.setItem("password", password);

        // Store user data in session storage

        sessionStorage.setItem("data", JSON.stringify(response.data.data,));

        console.log("response", response?.data?.data);
        toast(response?.data?.message);
        setEmail("");
        setPassword("");
        setTimeout(() => {
          if (response?.data?.data?.userData?.role === "Admin") {
            navigate("/consultants")
          } else {
            navigate(
              response?.data?.data?.userData?.jobTitle === ""
                ? "/profile"
                : "/welcome"
            )
          }
          /*  navigate(
             response?.data?.data?.userData?.role === "Admin"
               ? "/consultants"
               : "/welcome"
           ); */
          console.log(response)
        }, 2000);
      } else {
        console.log("error")
      }
    } catch (error) {
      // navigate('/Otp-verification')
      if (error?.response?.status === 402) {
        setTimeout(
          () =>
            navigate("/Otp-verification", {
              state: {
                data: email,
              },
            }),
          2000
        );
        toast(error?.response?.data?.message);
      } else {
        toast(error?.response?.data?.message);

        if (error?.response?.data?.message === "Please Verify Your Account by OTP") {
          setTimeout(
            () =>
              navigate("/Otp-verification", {
                state: {
                  data: email,
                },
              }),
            2000
          );
        }
      }
    }
  };
  return (
    <>
      {
        window.innerWidth < 500 ? (
          <div className="text-center text-white p-4 bg-red-500">
            Sorry! this portal is only operatable through desktop devices.
          </div>
        ) : (
          <div
            className="flex w-screen h-screen overflow-hidden"
            style={{ backgroundColor: "#F9FAFB", position: 'fixed' }}
          >
            <ToastContainer />
            <div
              className="w-1/2 h-full flex items-center justify-center relative"
              style={{ backgroundImage: `url(${Left})`, backgroundSize: "cover" }}
            >
              <>
                {/* ... Your existing JSX code for SignUp component */}

                {/* Example: Adding the icon to trigger handleIconClick */}
                <div className="absolute left-0 bottom-[-1px] pl-[5px] hover:shake">
                  <svg
                    width="75"
                    height="75"
                    viewBox="0 0 75 75"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={handleIconClick}
                    className="cursor-pointer w-[40px]"
                  >
                    <circle cx="37.5" cy="37.5" r="37.5" fill="#143C46" />
                    <path d="M41.9888 18.6838H27.4384C26.4891 18.6838 25.6128 18.8483 24.8277 19.1765C24.0428 19.5051 23.3126 19.9982 22.6551 20.6554C21.9978 21.3126 21.5048 22.0428 21.1762 22.828C20.8476 23.6128 20.6834 24.4895 20.6834 25.4388V39.6421C20.6834 40.5914 20.8476 41.4677 21.1762 42.2529C21.5048 43.038 21.9978 43.7679 22.6551 44.4255C23.3303 45.083 24.0609 45.5935 24.8457 45.904C25.6309 46.2326 26.4891 46.3971 27.4384 46.3971H33.6822C34.4128 46.3971 35.0151 46.9994 35.0151 47.7296C35.0151 47.8941 34.9786 48.0401 34.9421 48.1862C34.7046 49.0628 34.449 49.9391 34.1569 50.7785C33.8464 51.6735 33.5181 52.513 33.1527 53.335C32.9701 53.7547 32.751 54.156 32.5139 54.5764C33.7918 54.0099 34.9967 53.3531 36.1104 52.6225C37.2788 51.8558 38.3742 50.9979 39.3781 50.0667C40.4004 49.1174 41.3132 48.0766 42.1529 46.9629C42.4085 46.6165 42.8101 46.434 43.2118 46.434H48.5793C49.5286 46.434 50.3868 46.2695 51.1716 45.9409C51.9568 45.6123 52.687 45.1192 53.3627 44.4623C54.0199 43.8048 54.513 43.0749 54.8416 42.2897C55.1698 41.5046 55.3343 40.6279 55.3343 39.679V25.4753C55.3343 24.526 55.1698 23.6497 54.8416 22.8645C54.513 22.0794 54.0199 21.3495 53.3627 20.6919C52.7055 20.0344 51.9752 19.5416 51.1901 19.2134C50.4049 18.8848 49.529 18.7203 48.5793 18.7203H41.9888V18.6838ZM39.4566 35.3644H35.9877V34.9895C35.9877 34.3521 36.0531 33.8326 36.1873 33.4348C36.3215 33.0332 36.5204 32.6722 36.7857 32.3419C37.0507 32.0112 37.646 31.4312 38.5717 30.6015C39.0641 30.1665 39.3102 29.7683 39.3102 29.4071C39.3102 29.043 39.2104 28.7631 39.0143 28.5607C38.8147 28.3614 38.5153 28.2602 38.1137 28.2602C37.6801 28.2602 37.3247 28.4153 37.0417 28.7255C36.7579 29.0325 36.5774 29.5754 36.4989 30.3449L32.9551 29.8692C33.0765 28.4595 33.5501 27.3259 34.3732 26.466C35.1994 25.606 36.4648 25.1773 38.1693 25.1773C39.497 25.1773 40.5662 25.4774 41.3824 26.0744C42.4895 26.8874 43.0438 27.9664 43.0438 29.3156C43.0438 29.8754 42.9005 30.4186 42.6137 30.9381C42.3303 31.4573 41.744 32.095 40.8622 32.8437C40.2481 33.3733 39.8583 33.7947 39.6962 34.1153C39.5377 34.4331 39.4566 34.8511 39.4566 35.3644ZM35.8663 36.3623H39.5846V39.3292H35.8663V36.3623ZM34.0293 16.0184H48.5793C49.8572 16.0184 51.0625 16.2559 52.1943 16.7121C53.3077 17.1684 54.3304 17.8624 55.2432 18.7752C56.1563 19.688 56.8501 20.7103 57.3066 21.8241C57.7628 22.9379 58 24.1424 58 25.4391V39.6421C58 40.9388 57.7625 42.1433 57.3066 43.2571C56.8501 44.3702 56.1563 45.3925 55.2432 46.306C54.3304 47.2188 53.3081 47.8937 52.1943 48.3687C51.0809 48.8253 49.8757 49.0628 48.5793 49.0628H43.8693C43.048 50.1032 42.1533 51.0887 41.204 51.9837C40.0721 53.0426 38.8672 53.9912 37.5709 54.8313C36.2746 55.6891 34.8871 56.4381 33.4082 57.0766C31.9478 57.7157 30.3778 58.2453 28.7348 58.6834C28.2601 58.811 27.7489 58.665 27.4019 58.2815C26.9092 57.7341 26.9638 56.8947 27.5114 56.4016C28.2782 55.726 28.9354 55.0323 29.465 54.3382C29.9761 53.6633 30.3962 52.9688 30.7064 52.2574V52.239C31.0534 51.4722 31.3636 50.687 31.6376 49.9019C31.729 49.6282 31.8202 49.3361 31.9116 49.044H27.4203C26.1424 49.044 24.9375 48.8062 23.8053 48.35C22.6916 47.8934 21.6692 47.2 20.7565 46.2872C19.8437 45.3744 19.1499 44.3518 18.6934 43.2383C18.2372 42.1068 18 40.9019 18 39.624V25.4203C18 24.1421 18.2372 22.9372 18.6937 21.8053C19.1503 20.6916 19.844 19.6692 20.7568 18.7565C21.6696 17.8437 22.6919 17.1499 23.8057 16.6934C24.9195 16.2368 26.124 16 27.4203 16H34.0108L34.0293 16.0184Z" fill="#fff" />
                  </svg>
                </div>
              </>
            </div>

            <div className="w-1/2 mx-auto h-full flex items-center justify-center">

              <div className="text-center text-white p-4">
              </div>

              <div className="h-full w-full relative">

                <div className="flex justify-end mb-12 mt-6 mr-14">
                  <Link to='/signup'>
                    <img
                      className="hover:scale-105 transition duration-300"
                      src={logo}
                      alt="Logo"
                      width="200px"
                      height="200px"
                    />
                  </Link>
                </div>
                <div className="text-[30px] text-gray-900 font-bold flex justify-center mt-14 ms-14 me-14">
                  UME Health{" "}
                  <span className="text-[#2CA1C8] ms-1 text-[30px]">
                    {" "}
                    Referrals Portal{" "}
                  </span>{" "}
                </div>
                <div className="p-4 mx-auto rounded-xl hover:scale-105 transition duration-300 flex justify-center w-full items-center">
                  <div
                    className="mx-auto flex flex-col shadow-xl justify-center bg-white border rounded-xl p-5 border-4 hover:scale-105 transition duration-300"
                    style={{
                      borderTopColor: "#003942",
                      borderBottomColor: "#003942",
                      width: "400px",
                      paddingBottom: "10px",
                    }}
                  >
                    {/* <div className='text-2xl text-gray-500 font-bold flex justify-center'>Login to your existing account</div> */}
                    <form>
                      <label className="block mb-4 pt-3">
                        <span className="font-semibold mb-2 text-[#2ca1cb]">
                          {" "}
                          Email
                        </span>
                        <div className="flex relative items-center ">
                          <CiMail className=" absolute left-3 w-6 h-6 mr-2 text-gray-400 hover:shake" />
                          <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="pl-12 w-full p-2 py-3 border bg-white focus:bg-gray-200 rounded-md focus:border-sky-600 focus:outline-sky-600 bg-opacity-80"
                            placeholder="you@workemail.com"
                          />
                        </div>
                      </label>
                      <label className="block mb-2">
                        <span className="font-semibold mb-2 text-[#2ca1cb]">
                          {" "}
                          Password
                        </span>
                        <div className="flex relative items-center ">
                          {showPass ? (
                            <FaEyeSlash
                              className=" absolute right-1 w-6 h-6 mr-2 text-gray-400 hover:shake"
                              onClick={() => setShowPass(!showPass)}
                            />
                          ) : (
                            <FaEye
                              className=" absolute right-1 w-6 h-6 mr-2 text-gray-400 hover:shake"
                              onClick={() => setShowPass(!showPass)}
                            />
                          )}

                          <CiLock className=" absolute left-4 w-6 h-6 mr-2 text-gray-400 hover:shake" />
                          <input
                            type={showPass ? "text" : "password"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full p-2 py-3 pl-12 border bg-white focus:bg-gray-200 rounded-md focus:border-sky-600 focus:outline-sky-600 bg-opacity-80"
                            placeholder="Minimum 8-characters"
                          />
                        </div>
                      </label>
                      <button
                        onClick={(e) => handleLogin(e)}
                        className="flex justify-center mx-auto rounded-xl px-4 py-2 my-3 overflow-hidden relative group cursor-pointer border-2 font-medium text-[16px] border-sky-700 w-3/5 text-sky-700 hover:scale-105 duration-[900ms]"
                      >
                        <span className="absolute w-64 h-0 transition-all duration-[900ms] origin-center rotate-45 -translate-x-50 bg-sky-700 top-3/5 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
                        <span className="relative text-sky-500 transition duration-[900ms] group-hover:text-white ease">
                          Login
                        </span>
                      </button>
                    </form>
                    <p className="flex items-center justify-center">
                      <p className="pe-2 text-black text-sm">
                        Don't have an Account ?
                      </p>
                      <p
                        className="font-semibold underline text-sm"
                        style={{ color: "#2E90FA" }}
                      >
                        <NavLink to="/signup">Sign Up </NavLink>{" "}
                      </p>{" "}
                    </p>
                    <p className="flex items-center justify-center">
                      <p className="pe-2 text-center text-sm text-black">
                        Forgot Password ?{" "}
                      </p>
                      <p
                        className="font-semibold underline text-sm"
                        style={{ color: "#2E90FA" }}
                      >
                        <NavLink to="/forgot-password" className="ms-5">
                          Click Here
                        </NavLink>{" "}
                      </p>
                    </p>
                  </div>
                </div>
                <div
                  className={` right-2 bottom-0 ${isFooterVisible ? 'slide-in' : ''}`}
                  onAnimationEnd={() => { /* Add logic if needed when animation ends */ }}
                  style={{
                    /* Add more styles as needed */
                  }}
                >
                  {isFooterVisible &&

                    <Footer />}
                </div>
              </div>

            </div>
          </div>
        )
      }
    </>
  );
};

export default Login;
